<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">训练产品：</span>
					<el-select v-model="search_product" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in iAssistantIntegralProduct" :key="v.id" :value="v.id" :label="v.label"></el-option>
					</el-select>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchStartDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchEndDateChange"
					>
					</el-date-picker>
				</div>
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">添加</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="id"
						label="序号"
					>
					</el-table-column>
					<el-table-column
						prop="productLabel"
						label="训练产品"
					>
					</el-table-column>
					<el-table-column
						prop="integral"
						label="积分"
					>
					</el-table-column>
					<el-table-column
						label="图标"
					>
						<template slot-scope="scope">
							<img :src="scope.row.icon" alt="" style="width: 48px;">
						</template>
					</el-table-column>
					<el-table-column
						prop="time"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增 -->
		<add
			v-model="add_display"
			@onSuccess="addSuccess"
		></add>
		<!-- 新增 end -->
		
		<!-- 修改 -->
		<update
			v-model="update_display"
			:obj="update_data"
			@onSuccess="updateSuccess"
		></update>
		<!-- 修改 end -->
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import Update from './components/update.vue';
	import Api from '../../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default{
		mounted() {
			this.findExchanges();
		},
		data() {
			return{
				loading: false,
				
				search_product: '',
				search_startDate: '',
				search_endDate: '',
				
				total: 0,
				currentPage: 1,
				tableData: [],
				
				add_display: false,
				
				update_display: false,
				update_data: {}
			}
		},
		computed: {
			...mapState([
				'iAssistantIntegralProduct'
			])
		},
		methods: {
			/******************** @Events *************************/
			// 开始时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 结束时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.findExchanges();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.findExchanges();
				}
			},
			// 点击添加
			handleAddClick() {
				this.add_display = true;
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			// 点击删除
			handleDeleteClick(obj) {
				const that = this;
				that.$confirm(
					'此操作将删除该积分商品，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteExchange(obj.id);
					}
				).catch(
					() => {}
				);
			},
			
			/******************** @Function *************************/
			// 获取兑换列表
			findExchanges() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					productId: that.search_product,
					start: that.search_startDate,
					end: that.search_endDate
				};
				Api.findIAssistantIntegralExchanges(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								productId: v.productId,
								productLabel: that.getProductLabelById(v.productId),
								integral: v.pointsCost || '',
								icon: v.productIcon || '',
								time: v.createTs
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增成功
			addSuccess() {
				this.findExchanges();
			},
			// 修改成功
			updateSuccess() {
				this.findExchanges();
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startTime = new Date(this.search_startDate).getTime(),
						endTime = new Date(this.search_endDate).getTime();
					if (endTime < startTime) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			},
			// 根据产品id获取产品名称
			getProductLabelById(id) {
				let label = '';
				this.iAssistantIntegralProduct.forEach(v => {
					if (id == v.id) {
						label = v.label;
					}
				});
				return label;
			},
			// 删除兑换记录
			deleteExchange(id) {
				const that = this;
				that.loading = true;
				Api.deleteIAssistantIntegralExchange(id).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.findExchanges();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			Add,
			Update
		}
	}
</script>

<style>
</style>
